import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  ICreatePromo,
  IGetHelperProductsQuery,
  IGetPromoCodesQuery,
  IGetPromoCodesResponse,
  IHelperProductsResponse,
  IPromoCode,
  IUpdatePromoStatus
} from 'models/promoCodes'

export const promoCodesApi = {
  getPromoCodes(
    query: IGetPromoCodesQuery
  ): Promise<AxiosResponse<IGetPromoCodesResponse>> {
    return privateApi.get<IGetPromoCodesResponse>('admin/promo', {
      params: query
    })
  },
  exportStatistics(): Promise<AxiosResponse<Blob>> {
    return privateApi.get<Blob>('admin/promo/stats/export', {
      responseType: 'blob'
    })
  },
  getProducts(
    query: IGetHelperProductsQuery
  ): Promise<AxiosResponse<IHelperProductsResponse>> {
    return privateApi.get<IHelperProductsResponse>(
      'admin/promo/helpers/products',
      {
        params: query
      }
    )
  },
  getPromoCode(id: string): Promise<AxiosResponse<IPromoCode>> {
    return privateApi.get<IPromoCode>(`admin/promo/${id}`)
  },
  createPromoCode(data: ICreatePromo): Promise<AxiosResponse<IPromoCode>> {
    return privateApi.post<IPromoCode>('admin/promo', data)
  },
  changePromoCodeStatus(id: string, data: IUpdatePromoStatus) {
    return privateApi.patch<IPromoCode>(`admin/promo/${id}/status`, data)
  },
  updatePromoCode(
    id: string,
    data: ICreatePromo
  ): Promise<AxiosResponse<IPromoCode>> {
    return privateApi.put<IPromoCode>(`admin/promo/${id}`, data)
  }
}
